import { render } from "./WordpressMediaLibraryModal.vue?vue&type=template&id=31751c96&scoped=true"
import script from "./WordpressMediaLibraryModal.vue?vue&type=script&lang=js"
export * from "./WordpressMediaLibraryModal.vue?vue&type=script&lang=js"

import "./WordpressMediaLibraryModal.vue?vue&type=style&index=0&id=31751c96&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31751c96"]])

export default __exports__